import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  computed,
  input,
  output,
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { GrPopoverComponent } from '../popover';

import type { GrMenuItem } from './menu.types';

@Component({
  selector: 'gr-menu',
  imports: [RouterLink, GrPopoverComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: contents;' },
  templateUrl: './menu.component.html',
})
export class GrMenuComponent {
  @ViewChild('popover') popover!: GrPopoverComponent;

  readonly items = input.required<GrMenuItem[]>();
  readonly header = input<string>('');
  readonly minWidth = input<string>('var(--space-56)');
  readonly appendTo = input<'body' | HTMLElement | undefined>('body');
  readonly styleClass = input<string>('');
  readonly closeOnSelect = input<boolean>(true);

  readonly grHide = output<void>();

  protected readonly popoverClasses = computed(() => {
    const extra = this.styleClass();
    return extra ? `gr-menu-panel ${extra}` : 'gr-menu-panel';
  });

  toggle(event: Event): void {
    this.popover.toggle(event);
  }

  show(event: Event): void {
    this.popover.show(event);
  }

  hide(): void {
    this.popover.hide();
  }

  align(): void {
    this.popover.align();
  }

  protected onItemClick(item: GrMenuItem): void {
    item.action?.();
    if (this.closeOnSelect()) {
      this.popover.hide();
    }
  }
}
